import { WORLD_H, WORLD_W } from "./constants.js";
/** Axis-aligned wall rectangles in world space. */
export const WALLS = [
    { x: 0, y: 0, w: WORLD_W, h: 24 },
    { x: 0, y: WORLD_H - 24, w: WORLD_W, h: 24 },
    { x: 0, y: 0, w: 24, h: WORLD_H },
    { x: WORLD_W - 24, y: 0, w: 24, h: WORLD_H },
    { x: 180, y: 140, w: 120, h: 32 },
    { x: 500, y: 140, w: 120, h: 32 },
    { x: 320, y: 240, w: 160, h: 32 },
    { x: 200, y: 380, w: 140, h: 32 },
    { x: 460, y: 380, w: 140, h: 32 },
];
/** Team 0 vault (deposit zone), team 1 vault. */
export const VAULTS = [
    { team: 0, x: 32, y: WORLD_H / 2 - 50, w: 72, h: 100 },
    { team: 1, x: WORLD_W - 104, y: WORLD_H / 2 - 50, w: 72, h: 100 },
];
export function circleWallOverlap(cx, cy, r) {
    for (const w of WALLS) {
        const nx = Math.max(w.x, Math.min(cx, w.x + w.w));
        const ny = Math.max(w.y, Math.min(cy, w.y + w.h));
        const dx = cx - nx;
        const dy = cy - ny;
        if (dx * dx + dy * dy < r * r)
            return true;
    }
    return false;
}
export function circleVaultTeam(cx, cy, r) {
    for (const v of VAULTS) {
        const nx = Math.max(v.x, Math.min(cx, v.x + v.w));
        const ny = Math.max(v.y, Math.min(cy, v.y + v.h));
        const dx = cx - nx;
        const dy = cy - ny;
        if (dx * dx + dy * dy < r * r)
            return v.team;
    }
    return null;
}
//# sourceMappingURL=map.js.map